<template>
  <!-- The game's actions (SPEC §5.3): one button at the end of the game's header line, opening a short list. -->
  <div class="game-actions" v-click-outside="close">
    <button type="button" class="open btn-icon" :aria-label="t('game-actions')" :aria-expanded="open ? 'true' : 'false'"
            @click="open = !open">⋯</button>
    <div v-if="open" class="list" role="menu">
      <p v-if="heading" class="heading">{{ heading }}</p>
      <p v-if="guard" class="guard">{{ guard }}</p>
      <template v-for="a in actions">
        <hr v-if="a.danger" :key="a.key + '-line'"/>
        <button :key="a.key" type="button" role="menuitem" :class="{ danger: a.danger }"
                :disabled="a.disabled" @click="choose(a.key)">{{ a.text }}</button>
      </template>
    </div>
  </div>
</template>

<script>
import { t } from '@/texts';

export default {
  name: 'GameActions',

  props: {
    // [{ key, text, disabled, danger }], in order.
    actions: { type: Array, required: true },
    // Why the actions are disabled, if they are.
    guard: { type: String, default: null },
    // A grey first line, e.g. the game's number.
    heading: { type: String, default: null },
  },

  directives: {
    // Closes the list on a tap or click anywhere else on the page. Pointer-down (and touch-start, for
    // browsers without pointer events), not click: the board cancels the click of a tap.
    clickOutside: {
      bind(el, binding) {
        el.__outside = e => { if (!el.contains(e.target)) binding.value(); };
        for (const type of ['pointerdown', 'touchstart']) document.addEventListener(type, el.__outside, true);
      },
      unbind(el) {
        for (const type of ['pointerdown', 'touchstart']) document.removeEventListener(type, el.__outside, true);
      },
    },
  },

  data() {
    return { open: false };
  },

  methods: {
    t,

    close() {
      this.open = false;
    },

    choose(key) {
      this.open = false;
      this.$emit('action', key);
    },
  },
}
</script>

<style scoped>
.game-actions {
  position: relative;
}

.open {
  line-height: 1;
}

.list {
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 10;
  min-width: 160px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  padding: 4px 0;
  text-align: left;
}

.list button {
  display: block;
  width: 100%;
  padding: 10px 16px;
  border: 0;
  background: none;
  text-align: left;
  font-size: 16px;
  white-space: nowrap;
}

.list button:disabled {
  color: #aaa;
}

.list button.danger {
  color: #e00;
}

.list button.danger:disabled {
  color: #f0a0a0;
}

.list hr {
  margin: 4px 0;
  border: 0;
  border-top: 1px solid #eee;
}

.heading {
  margin: 6px 16px 2px;
  color: #999;
  font-size: 13px;
  white-space: nowrap;
}

.guard {
  margin: 6px 16px;
  color: #f00;
  font-size: 14px;
  white-space: nowrap;
}
</style>
